import { SyncIcon } from "@primer/octicons-react";
import { Box } from "@primer/react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Transition } from "semantic-ui-react";
import { hocSinhApi } from "../../../../api/hocSinhApi";
import { khoanNopGroupApi } from "../../../../api/khoanNopGroupApi";
import { saleSetKhoanNopGroupTypeApi } from "../../../../api/saleSetKhoanNopGroupTypeApi";
import { saleSetDichVuApi, SF_SALESET_REGISTER_DICHVU_INSERT } from "../../../../api/saleSetRegisterDichVu";
import DataGrid from "../../../../components/data-grid";
import { IDataGridColumn } from "../../../../components/data-grid/type/IDataGridProps";
import HocSinhShortInfoNew from "../../../../components/hoc-sinh/HocSinhShortInfoNew";
import Button from "../../../../components/ui/button";
import Text from "../../../../components/ui/text";
import { useCommonContext } from "../../../../contexts/common";
import { showNotify } from "../../../../helpers/toast";
import { ts_hocsinh_viewmodel } from "../../../../models/response/hocsinh/ts_hocsinh";
import { sf_saleset_register_dichvu, sf_saleset_register_dichvu_viewmodel } from "../../../../models/response/sale-set-dichvu/sf_saleset_register_dichvu";
import { loadKhoanNopGroupStart } from "../../../../state/actions/khoanNopGroupActions";
import { RootState } from "../../../../state/reducers";
import DangKyDichVuHocSinhModal from "./DangKyDichVuHocSinhModal";
const kyNops = [
    { id: 10, text: "Theo năm" },
    { id: 5, text: "Theo kỳ" },
    { id: 13, text: "Theo tháng" },
];

type DangKyDichVuHocSinhProps = {
    ts_hocsinh_id: number,
}
const DangKyDichVuHocSinh = (props: DangKyDichVuHocSinhProps) => {
    const dispatch = useDispatch();

    const [isShowDetailModal, setIsShowDetailModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [dataSourceFilter, setDataSourceFilter] = useState<sf_saleset_register_dichvu_viewmodel[]>([]);
    const { translate, checkAccesiableToV2 } = useCommonContext();
    const { nam_hoc: param_nam_hoc } = useSelector((x: RootState) => x.common);
    const { dm_coso_id: param_co_so } = useSelector((x: RootState) => x.common);
    const sf_khoannop_groups = useSelector(
        (x: RootState) => x.khoanNopGroup.sf_khoannop_groups
    ); const [ts_hocsinh_viewmodel, set_ts_hocsinh_viewmodel] = useState<ts_hocsinh_viewmodel>();
    const [dataEditing, setdataEditing] = useState<sf_saleset_register_dichvu_viewmodel>();
    const [khoanNopFilter, setKhoanNopFilter] = useState<number[]>([]);
    const [groupTypeRows, setGroupTypeRows] = useState<any[]>([]);
    const groupTypeRowsRef = useRef<any[]>([]);
    const isSavingGroupTypeRef = useRef(false);
    useEffect(() => {
        dispatch(loadKhoanNopGroupStart());
    }, [dispatch]);


    const isAccessibleUpdate = useMemo(() => {
        if (!checkAccesiableToV2(SF_SALESET_REGISTER_DICHVU_INSERT, 'POST')) return false;
        return true;
    }, [checkAccesiableToV2]);
    void isAccessibleUpdate;

    const handleReloadHocSinh = useCallback(async () => {
        const res = await hocSinhApi.selectByIdNamHoc({ ts_hocsinh_id: props.ts_hocsinh_id, nam_hoc: param_nam_hoc });
        if (res.is_success) {
            set_ts_hocsinh_viewmodel(res.data);
        }
    }, [props.ts_hocsinh_id, param_nam_hoc]);

    const handleReloadDichVus = useCallback(async () => {
        setIsLoading(true);
        try {
            const res = await saleSetDichVuApi.select_by_hocsinh({
                ts_hocsinh_id: props.ts_hocsinh_id,
                nam_hoc: param_nam_hoc,
            });
            if (res.is_success) {
                setDataSourceFilter((res.data || []).filter((x: any) => x.ts_hocsinh_id === props.ts_hocsinh_id));
            }
        } finally {
            setIsLoading(false);
        }
    }, [props.ts_hocsinh_id, param_nam_hoc]);

    const handleReloadGroupType = useCallback(async () => {
        if (!props.ts_hocsinh_id || !param_nam_hoc) return;

        // Gọi API để lấy dữ liệu hình thức đăng ký của học sinh
        const resGroupType = await saleSetKhoanNopGroupTypeApi.select_by_hocsinh({
            ts_hocsinh_id: props.ts_hocsinh_id,
            nam_hoc: param_nam_hoc,
        });

        const groupTypeMap = new Map<number, number>(); // sf_khoannop_group_id -> sf_saleset_register_type_id
        if (resGroupType.is_success && resGroupType.data) {
            (resGroupType.data as any[]).forEach((x: any) => {
                groupTypeMap.set(x.sf_khoannop_group_id, x.sf_saleset_register_type_id);
            });
        }

        const res = await khoanNopGroupApi.select_khoannop_by_hs({
            ts_hocsinh_id: props.ts_hocsinh_id,
            dm_coso_id: param_co_so,
            nam_hoc: param_nam_hoc,
        });
        if (res.is_success) {
            const allDichVus = (sf_khoannop_groups || []).filter(
                (x: any) => x.dm_coso_id === param_co_so && (x.is_dichvu || x.is_dichvu_fixed)
            );
            const registeredMap = new Map<number, any>();
            (res.data || []).forEach((x: any) => registeredMap.set(x.sf_khoannop_group_id, x));

            // Lấy tất cả dịch vụ của cơ sở, sau đó map với dữ liệu đăng ký của học sinh
            const merged = allDichVus
                .map((dv: any) => {
                    const reg = registeredMap.get(dv.id);
                    // Ưu tiên lấy từ groupTypeMap (sf_saleset_khoannopgroup_type), nếu không có thì lấy từ reg
                    const registeredTypeId = groupTypeMap.get(dv.id) ?? reg?.sf_saleset_register_type_id ?? 0;
                    const isChecked = registeredTypeId > 0;

                    return {
                        sf_khoannop_group_id: dv.id,
                        ma_khoan_nop_group: dv.ma_khoan_nop_group,
                        ten_khoan_nop_group: dv.ten_khoan_nop_group,
                        sf_saleset_register_type_id: registeredTypeId,
                        is_checked: isChecked,
                    };
                })
                .filter((item: any) => item.is_checked);
            groupTypeRowsRef.current = merged;
            setGroupTypeRows(merged);
        }
    }, [props.ts_hocsinh_id, param_nam_hoc, param_co_so, sf_khoannop_groups]);

    const handleSaveGroupType = useCallback(async (rows: any[]) => {
        if (isSavingGroupTypeRef.current) return;
        isSavingGroupTypeRef.current = true;
        try {
            const res = await saleSetKhoanNopGroupTypeApi.insert_multiple({
                list_khoannop_group: rows,
                ts_hocsinh_id: props.ts_hocsinh_id,
                nam_hoc: param_nam_hoc,
            });
            if (res.is_success) {
                showNotify({
                    message: `Cập nhật thành công`,
                    type: "success"
                })
            }
            else {
                showNotify({
                    message: `Có lỗi`,
                    type: "warning"
                })
            }
        } finally {
            isSavingGroupTypeRef.current = false;
        }
    }, [props.ts_hocsinh_id, param_nam_hoc]);

    useEffect(() => {
        handleReloadDichVus();
        handleReloadHocSinh();
        handleReloadGroupType();
    }, [handleReloadDichVus, handleReloadHocSinh, handleReloadGroupType]);

    const handleSubmitDetailModal = async (data: sf_saleset_register_dichvu_viewmodel) => {
        const datasend: sf_saleset_register_dichvu = {
            id: data.id,
            ts_hocsinh_id: data.ts_hocsinh_id,
            nam_hoc: data.nam_hoc,
            sf_khoannop_group_id: data.sf_khoannop_group_id,
            sf_saleset_register_dichvu_status_id: data.sf_saleset_register_dichvu_status_id,
            is_active: data.is_active,
            tu_ngay: data.tu_ngay,
            den_ngay: data.den_ngay,
            sf_saleset_register_type_id: data.sf_saleset_register_type_id
        }
        const res = await saleSetDichVuApi.Update(datasend);
        if (res.is_success) {
            setIsShowDetailModal(false)
            handleReloadDichVus();
            showNotify({
                message: `Cập nhật thành công`,
                type: "success"
            })
        }
        else {
            showNotify({
                message: `Có lỗi`,
                type: "warning"
            })
        }
    }
    const btnEdit_click = useCallback((data: any) => {
        setdataEditing(data);
        setIsShowDetailModal(true);
    }, []);
    void btnEdit_click;

    const formatDate = useCallback((date: string | Date | null) => {
        if (!date) return "";
        return new Intl.DateTimeFormat("vi-VN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).format(new Date(date));
    }, []);

    const dichVuGroups = useMemo(() => {
        const list = (sf_khoannop_groups || []).filter(
            (x: any) => x.dm_coso_id === param_co_so && (x.is_dichvu || x.is_dichvu_fixed)
        );
        if (khoanNopFilter.length > 0) {
            return list.filter((x: any) => khoanNopFilter.includes(x.id));
        }
        return list;
    }, [sf_khoannop_groups, param_co_so, khoanNopFilter]);

    const dataSourcePivot = useMemo(() => {
        const tsId = Number(props.ts_hocsinh_id || 0);
        if (!tsId) return [];

        const first = (dataSourceFilter || [])[0] as any;
        const row: any = {
            ts_hocsinh_id: tsId,
            ma_hs: ts_hocsinh_viewmodel?.ma_hs || first?.ma_hs || "",
            ho_ten: ts_hocsinh_viewmodel?.ho_ten || first?.ho_ten || "",
            ten_lop: first?.ten_lop || "",
            ten_khoi: first?.ten_khoi || "",
            ten_he: first?.ten_he || "",
            dm_truong_id: (ts_hocsinh_viewmodel as any)?.dm_truong_id || first?.dm_truong_id || 0,
            dm_khoi_id: (ts_hocsinh_viewmodel as any)?.dm_khoi_id || first?.dm_khoi_id || 0,
            dm_he_id: (ts_hocsinh_viewmodel as any)?.dm_he_id || first?.dm_he_id || 0,
            ngay_sinh: (ts_hocsinh_viewmodel as any)?.ngay_sinh || first?.ngay_sinh || "",
        };

        (dataSourceFilter || []).forEach((r: any) => {
            const gid = Number(r.sf_khoannop_group_id || 0);
            if (!gid) return;
            row[`REC_${gid}`] = r;
            row[`TT_${gid}`] = r.trang_thai_dich_vu || "";
            row[`TTID_${gid}`] = r.sf_saleset_register_dichvu_status_id;
            row[`TN_${gid}`] = r.tu_ngay || "";
            row[`DN_${gid}`] = r.den_ngay || "";
        });

        return [row];
    }, [dataSourceFilter, props.ts_hocsinh_id, ts_hocsinh_viewmodel]);

    const columns = useMemo<IDataGridColumn[]>(() => {
        const base: IDataGridColumn[] = [
            {
                id: "ma_hs",
                dataField: "ma_hs",
                width: 100,
                fixed: "left",
                isMainColumn: true,
                caption: translate("Mã HS"),
            },
            {
                id: "ho_ten",
                dataField: "ho_ten",
                width: 200,
                fixed: "left",
                caption: translate("Học sinh"),
                cellRender: (data: any) => {
                    return <HocSinhShortInfoNew data={data} onClick={() => { }} />;
                },
            },
            {
                id: "ten_lop",
                dataField: "ten_lop",
                caption: translate("Trường lớp"),
                width: 150,
                cellRender: (data: any) => {
                    return (
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "baseline",
                            }}
                        >
                            <Box sx={{ display: "flex" }}>
                                <Box sx={{ fontWeight: 600 }}>{data.ten_lop || ""}</Box>
                            </Box>
                            <Box sx={{ color: "fg.muted" }}>
                                {data.ten_khoi || ""}{data.ten_khoi || data.ten_he ? ", " : ""}{data.ten_he ? `Hệ ${data.ten_he}` : ""}
                            </Box>
                        </Box>
                    );
                },
            },
        ];

        const dynamic: IDataGridColumn[] = (dichVuGroups || []).map((dv: any) => {
            const gid = dv.id;
            const count = (dataSourceFilter || []).filter((x: any) => x.sf_khoannop_group_id === gid).length;
            const captionText = `${dv.ten_khoan_nop_group} (${count})`;
            const cols: IDataGridColumn[] = [
                {
                    id: `DV_TT_${gid}`,
                    caption: translate("Trạng thái"),
                    dataField: `TT_${gid}`,
                    width: 130,
                    align: "center",
                    cellRender: (row: any) => {
                        const text = row?.[`TT_${gid}`];
                        return (
                            <span style={{ fontWeight: 500 }}>
                                {text}
                            </span>
                        );
                    },
                },
                {
                    id: `DV_TIME_${gid}`,
                    caption: translate("Thời gian"),
                    dataField: `TN_${gid}`,
                    width: 220,
                    align: "center",
                    cellRender: (row: any) => {
                        const tu = row?.[`TN_${gid}`];
                        const den = row?.[`DN_${gid}`];
                        if (!tu && !den) return <span></span>;
                        return (
                            <div style={{ display: "flex", alignItems: "center", gap: "5px", fontWeight: 500 }}>
                                <span>{formatDate(tu)}</span>
                                <span>-</span>
                                <span>{formatDate(den)}</span>
                            </div>
                        );
                    },
                },
            ];

            if (dv.ma_khoan_nop_group === "BAN_TRU" || dv.code_dich_vu === "BAN_TRU") {
                cols.push({
                    id: `DV_LOAI_DK_${gid}`,
                    caption: translate("Loại đăng ký"),
                    width: 140,
                    align: "center",
                    cellRender: (row: any) => {
                        const rec = row?.[`REC_${gid}`];
                        const val = rec?.ma_combo;
                        return <span style={{ fontWeight: 500 }}>{val || ""}</span>;
                    },
                });
            }

            return {
                id: `DV_${gid}`,
                caption: captionText,
                align: "center",
                columns: cols,
            } as IDataGridColumn;
        });

        return [...base, ...dynamic];
    }, [dichVuGroups, formatDate, translate, dataSourceFilter]);

    const groupTypeColumns = useMemo<IDataGridColumn[]>(() => {
        return [
            {
                id: "ten_khoan_nop_group",
                dataField: "ten_khoan_nop_group",
                caption: translate("Khoản nộp"),
                width: 220,
                isMainColumn: true,
                cellRender: (row: any) => (
                    <Box sx={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ fontWeight: 600 }}>{row.ten_khoan_nop_group}</span>
                        <span style={{ fontSize: 12, color: "#6e7781" }}>{row.ma_khoan_nop_group}</span>
                    </Box>
                ),
            },
            ...kyNops.map((ky) => ({
                id: `ky_${ky.id}`,
                caption: ky.text,
                width: 110,
                align: "center" as const,
                cellRender: (row: any) => {
                    const checked = row.sf_saleset_register_type_id === ky.id;
                    return (
                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => {
                                const newRows = groupTypeRowsRef.current.map((x) =>
                                    x.sf_khoannop_group_id !== row.sf_khoannop_group_id ? x : {
                                        ...x,
                                        sf_saleset_register_type_id: checked ? 0 : ky.id,
                                        is_checked: !checked,
                                    }
                                );
                                groupTypeRowsRef.current = newRows;
                                setGroupTypeRows([...newRows]);
                                handleSaveGroupType(newRows);
                            }}
                            style={{ cursor: "pointer", width: 16, height: 16 }}
                        />
                    );
                },
            })),
        ];
    }, [translate, handleSaveGroupType]);
    return (
        <React.Fragment>
            <Box sx={{ p: 2 }}>
                <Transition
                    animation="scale"
                    visible={true}
                    duration={200}
                    transitionOnMount={true}
                >
                    <div>
                        <div className="row">
                            <Box className="col-md-12" sx={{ mt: 1 }}>
                                <DataGrid
                                    title={<Text text={translate("Danh sách đăng ký dịch vụ")} sx={{ fontSize: 16, fontWeight: 600 }} />}
                                    dataSource={dataSourcePivot}
                                    keyExpr="ts_hocsinh_id"
                                    isLoading={isLoading}
                                    exportConfig={{
                                        enable: true,
                                        fileName: "danh-sach-dang-ky-dich-vu",
                                    }}
                                    filterRow={{
                                        enable: true
                                    }}
                                    searchEnable={true}
                                    actionComponent={
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                                            <Button
                                                text={translate("Làm mới")}
                                                leadingVisual={SyncIcon}
                                                variant="default"
                                                size="small"
                                                isLoading={isLoading}
                                                onClick={handleReloadDichVus}
                                            />

                                        </Box>
                                    }
                                    columns={columns}
                                />
                            </Box>

                            <Box className="col-md-12" sx={{ mt: 2 }}>
                                <DataGrid
                                    title={<Text text={translate("Hình thức đăng ký dịch vụ")} sx={{ fontSize: 16, fontWeight: 600 }} />}
                                    dataSource={groupTypeRows}
                                    keyExpr="sf_khoannop_group_id"
                                    isLoading={false}
                                    columns={groupTypeColumns}
                                    filterRow={{ enable: false }}
                                    paging={{ enable: false }}
                                    exportConfig={{ enable: false }}
                                    actionComponent={
                                        <Button
                                            text={translate("Làm mới")}
                                            leadingVisual={SyncIcon}
                                            variant="default"
                                            size="small"
                                            onClick={handleReloadGroupType}
                                        />
                                    }
                                />
                            </Box>

                            <DangKyDichVuHocSinhModal
                                isOpen={isShowDetailModal}
                                animationOf=""
                                sf_saleset_register_dichvu_editting={dataEditing}
                                title={`${dataEditing ? `Cập nhật` : "Đăng ký dịch vụ"}`}
                                onClose={() => {
                                    setdataEditing(undefined);
                                    setIsShowDetailModal(false);
                                    handleReloadDichVus();
                                }}
                                onSubmit={handleSubmitDetailModal}
                                ts_hocsinh={ts_hocsinh_viewmodel}
                            />
                        </div>
                    </div>
                </Transition>
            </Box>
        </React.Fragment>
    );
};
export default DangKyDichVuHocSinh;
